// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__15a0z","search":"Settings_search__JKsE6","filter":"Settings_filter__P9aYd"};